"use client"

import { useTrackViewProduct } from "src/tracking/api"
import { StorefrontDetailProduct, StorefrontDetailVariant } from "src/types/storefront"

export type TrackViewProductProps = {
  product: StorefrontDetailProduct
  variant: StorefrontDetailVariant
}

export function TrackViewProduct({ product, variant }: TrackViewProductProps) {
  useTrackViewProduct(product, variant)

  return null
}
